import axios from '@/services/axiosConfig'
import ParamMaker from '@/utils/modules/ParamMaker'

const endPoint = {
	lookupSafetySummary: instId => `/institute/${instId}/safety/summary`,
	lookupMsdsList: instId => `/institute/${instId}/safety/msds/list`,
	lookupHarmfulChemicalList: instId =>
		`/institute/${instId}/safety/harmfulchemical/list?`,
	lookupSpecialManagementList: instId =>
		`/institute/${instId}/safety/specialmanagement/list`,
	lookupHealthCheck: instId =>
		`/institute/${instId}/safety/specialdiagnosis/list`,
	lookupHealthCheckInfo: instId =>
		`/institute/${instId}/safety/specialdiagnosis`,
	lookupHealthCheckUsageHistory: instId =>
		`/institute/${instId}/safety/specialdiagnosis/inventory/log`,
	lookupHealthCheckHistory: instId =>
		`/institute/${instId}/safety/specialdiagnosis/log/list`,
	deleteHealthCheckHistory: (instId, ids) =>
		`/institute/${instId}/safety/specialdiagnosis/log?${ParamMaker.setArrayString(
			'ids',
			ids
		)}`,
	lookupDangerStorageList: instId =>
		`/institute/${instId}/safety/dangerstorage/list`,
	lookupStorageStatusList: instId =>
		`/institute/${instId}/safety/dangerstorage/status`,
	lookupStorageLegalList: instId =>
		`/institute/${instId}/safety/dangerstorage/legal`,
	lookupLawMaterialList: instId =>
		`/institute/${instId}/safety/legal/items/count/list`,
}

const SafetyAPI = {
	lookupSafetySummary: instId =>
		axios.get(endPoint.lookupSafetySummary(instId)),
	lookupMsdsList: (instId, params) =>
		axios.get(endPoint.lookupMsdsList(instId), { params: params }),
	lookupHarmfulChemicalList: (instId, params) =>
		axios.get(endPoint.lookupHarmfulChemicalList(instId), {
			params: params,
		}),
	lookupSpecialManagementList: (instId, params) =>
		axios.get(endPoint.lookupSpecialManagementList(instId), {
			params: params,
		}),
	lookupHealthCheck: (instId, params) =>
		axios.get(endPoint.lookupHealthCheck(instId), { params: params }),
	lookupHealthCheckInfo: (instId, params) =>
		axios.get(endPoint.lookupHealthCheckInfo(instId), { params: params }),
	lookupHealthCheckUsageHistory: (instId, params) =>
		axios.get(endPoint.lookupHealthCheckUsageHistory(instId), {
			params: params,
		}),
	lookupHealthCheckHistory: (instId, params) =>
		axios.get(endPoint.lookupHealthCheckHistory(instId), {
			params: params,
		}),
	deleteHealthCheckHistory: (instId, ids) =>
		axios.delete(endPoint.deleteHealthCheckHistory(instId, ids)),
	lookupDangerStorageList: (instId, params) =>
		axios.get(endPoint.lookupDangerStorageList(instId), { params: params }),
	lookupStorageStatusList: (instId, params) =>
		axios.get(endPoint.lookupStorageStatusList(instId), { params: params }),
	lookupStorageLegalList: (instId, params) =>
		axios.get(endPoint.lookupStorageLegalList(instId), { params: params }),
	lookupLawMaterialList: (instId, params) =>
		axios.get(endPoint.lookupLawMaterialList(instId), { params: params }),
}

export default SafetyAPI
